// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-PrimaryButton-module--cls1--1SYoy","cls2":"contacts-PrimaryButton-module--cls2--1jpeh contacts-PrimaryButton-module--cls1--1SYoy"};